import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=a00c3534&scoped=true&"
import script from "./Exam.vue?vue&type=script&lang=js&"
export * from "./Exam.vue?vue&type=script&lang=js&"
import style0 from "./Exam.vue?vue&type=style&index=0&id=a00c3534&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c3534",
  null
  
)

export default component.exports